import { Menu } from '@ui/themed';
import { t } from 'i18next';
import type { MenuItem } from '../menu/types';

/** A page header shows one secondary action as a button; two or more become a menu. */
export function singleSecondaryAction(actions?: MenuItem[]): MenuItem | undefined {
  return actions?.length === 1 ? actions[0] : undefined;
}

/** The "More actions" menu, rendered only when there's more than one action. */
export function SecondaryActionsMenu({ actions }: { actions?: MenuItem[] }) {
  if (!actions || actions.length <= 1) {
    return null;
  }

  return (
    <Menu
      collapsible
      items={actions.map((action) => ({
        label: action.label,
        icon: action.icon,
        onClick: action.onClick,
        disabled: action.disabled,
        danger: action.danger,
      }))}
      buttonText={t('buttons:more_actions')}
      align="end"
    />
  );
}
